import {
  getContacts,
  postContact,
  postConnection,
  deleteConnection,
  putContact,
  deleteContact,
  getSpillover,
  deleteNumber,
  postSpillover
} from '@/api/user/contacts'

/**
* Fetch user behavior from API
*/
const fetchContacts = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    getContacts()
      .then((response) => {
        if (response) {
          commit('FETCH_USER_CONTACTS_RESPONSE', response)
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE', error)
        reject(error)
      })
  })
}

/**
* Set number as users primary
*/
const addContact = async ({ commit }, contact) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    postContact(contact)
      .then((response) => {
        if (response) {
          commit('USER_CONTACTS_ADD_CONTACT_RESPONSE')
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}

const createConnection = async ({ commit }, contact) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    postConnection(contact)
      .then((response) => {
        if (response) {
          commit('USER_CONTACTS_ADD_CONNECTION_RESPONSE')
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}
const removeConnection = async ({ commit }, connectionId) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    deleteConnection(connectionId)
      .then((response) => {
        if (response) {
          commit('USER_CONTACTS_REMOVE_CONNECTION_RESPONSE')
          resolve(true)
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}
const editContact = async ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    const firstStepDeleteNumber = (data) => {
      return new Promise((resolve, reject) => {
        if (data.numberId) {
          deleteNumber(data.numberId).then((response) => {
            if (response) {
              resolve(data)
            } else {
              reject(Error('Unknown server response'))
            }
          }).catch((error) => {
            reject(error)
          })
        } else {
          resolve(data)
        }
      })
    }
    const secoundStepUpdateContact = (data) => {
      return new Promise((resolve, reject) => {
        putContact(data.contact).then((response) => {
          if (response) {
            resolve(response)
          } else {
            reject(Error('Unknown server response'))
          }
        }).catch((error) => {
          reject(error)
        })
      })
    }

    firstStepDeleteNumber(data)
      .then(data => secoundStepUpdateContact(data))
      .then(data => {
        commit('USER_CONTACTS_EDIT_CONTACT_RESPONSE')
        resolve(true)
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}

const removeContact = async ({ commit }, contactId) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    deleteContact(contactId)
      .then(response => {
        if (!response) {
          commit('USER_CONTACTS_REMOVE_CONTACT_RESPONSE')
          resolve(true)
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}

const fetchSpillover = async ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    getSpillover()
      .then((response) => {
        if (response) {
          commit('USER_CONTACTS_FETCH_SPILLOVER_RESPONSE')
          resolve(response)
        } else {
          reject(Error('No response from server'))
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}

const setSpillover = async ({ commit }, didGroupId) => {
  return new Promise((resolve, reject) => {
    commit('USER_CONTACTS_SUBMIT')

    postSpillover(didGroupId)
      .then((response) => {
        if (!response) { // No response if success...
          commit('USER_CONTACTS_ADD_CONTACT_RESPONSE')
          resolve(true)
        } else {
          reject(Error(response))
        }
      })
      .catch((error) => {
        commit('USER_CONTACTS_ERROR_RESPONSE')
        reject(error)
      })
  })
}

export default {
  fetchContacts,
  addContact,
  createConnection,
  removeConnection,
  editContact,
  removeContact,
  fetchSpillover,
  setSpillover
}



// WEBPACK FOOTER //
// ./src/store/modules/user/contacts/actions.js